<template>
  <div class="mt-5" v-if="nextInvoiceDate">
     <loading :active.sync="loading"
        :is-full-page="true"></loading>
    <h2>Oppgjør</h2>
    <p class="lead">
      Alle verdibevis som løses inn og legges til oppgjør før
      <strong>{{ formattedNextInvoiceDate(nextInvoiceDate) }}</strong
      >, vil du motta oppgjør for senest
      <strong>{{ formattedNextInvoiceDate(nextExpiryDate) }}</strong> (Betalingsvilkår
      {{ user.supplier.invoice_payment_interval }} dager).
    </p>
    <div class="section">
      <h4>
        Løst inn - ikke lagt til oppgjør
      </h4>
      <b-alert :show="invoiceSum < 0" variant="danger" class="">
        <p>
          <strong>Hei!</strong> Du har en gjeld som overgår det fakturerte beløpet, når du har
          innløste verdibevis til en verdi som overgår {{ -invoiceSum.toFixed(2) }} kr vil du ha
          mulighet å legge disse til fakturering. For mer info vennnligst ta kontakt med oss.
        </p>
      </b-alert>
      <add-to-invoice />
      <hr />

      <b-alert show :variant="user.supplier.auto_add_to_invoice ? 'success' : 'info'">
        <div v-if="!user.supplier.auto_add_to_invoice">
            Ønsker du at dine innløste verdibevis skal legges til oppgjør automatisk hver måned, huker du av på "Legg
            innløste gavekort til oppgjør" under.

          <hr />
        </div>

        <b-form-checkbox plain :checked="!!user.supplier.auto_add_to_invoice" @change="updateInvoiceAutoAdd">
          <span v-if="!user.supplier.auto_add_to_invoice">Legg innløste gavekort til oppgjør</span>
          <span v-else>Legger automatisk innløste gavekort til oppgjør</span>
        </b-form-checkbox>
      </b-alert>
    </div>
    <div class="section">
      <h4>
        Lagt til oppgjør
        <small class="text-muted" v-if="nextInvoiceDate">
          Bilag genereres {{ formattedNextInvoiceDate(nextInvoiceDate) }}
        </small>
      </h4>
      <next-invoice />
    </div>
    <div class="section">
      <h4>Oppgjørshistorikk</h4>
      <invoice-list />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { format, parseISO } from 'date-fns';
import { nb } from 'date-fns/locale';
import Loading from 'vue-loading-overlay';

import InvoiceList from '@/components/invoices/InvoiceList.vue';
import NextInvoice from '@/components/invoices/NextInvoice.vue';
import AddToInvoice from '@/components/invoices/AddToInvoice.vue';

export default {
  name: 'invoices',
  components: {
    InvoiceList,
    NextInvoice,
    AddToInvoice,
    Loading
  },
  mounted() {
    if (this.invoices.length === 0) {
      this.getInvoices();
    }

    this.getUser();
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      nextInvoiceDate: 'invoices/nextInvoiceDate',
      nextExpiryDate: 'invoices/nextExpiryDate',
      user: 'auth/getUser',
      invoiceSum: 'invoices/currentInvoiceSum',
      invoices: 'invoices/invoices',
    }),
  },
  methods: {
    ...mapActions({
      getInvoices: 'invoices/getInvoices',
      getUser: 'auth/getUser',
      setAutoAddToInvoice: 'auth/setAutoAddToInvoice',
    }),
    formattedNextInvoiceDate(date) {
      return format(parseISO(date), 'd MMMM', { locale: nb });
    },

    updateInvoiceAutoAdd(status) {
      this.setAutoAddToInvoice().then(() => {
        this.user.supplier.auto_add_to_invoice = status;

        this.$store.commit('auth/SET_USER', this.user);

        this.$bvToast.toast(
          `Automatisk fakturering er ${status ? 'aktivert' : 'deaktivert'}`,
          {variant: 'success', title: 'Endringen er lagret!', autoHideDelay: 5000}
        );
      });
    },
  },
};
</script>

<style scoped>
.alert {
  transition: all 0.3s ease-in-out;
}
</style>
